import React, { Component } from "react";

import "./header.scss";

import Menu from "./menu/mapMenu";
import Address from "./address/address";
import { Link } from "react-router-dom";
class Header extends Component {
	render() {
		return (
			<div className={this.props.className}>
				<Link to="/">
				<img
					id="logo"
					src="/sis/images/map/logo.png"
					alt="전남광주통합특별시 스마트도시분석포털"
					onClick={() => {
						//window.location = "/main";
						//this.props.history.push("/main");
						//window.location.href = "/main";
					}}
				/>
				</Link>
				<Address />
				<Menu />
			</div>
		);
	}
}

export default Header;
